module.exports = __webpack_public_path__ + "static/media/takinCar.467b4556.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/takinCar.png
// module id = 691
// module chunks = 2